import React, { Component } from 'react';
import './CallbackForm.css';

// Utils

var trim = function() {
    var TRIM_RE = /^\s+|\s+$/g
    return function trim(string) {
        return string.replace(TRIM_RE, '')
    }
}()

function $c(staticClassName, conditionalClassNames) {
    var classNames = []
    if (typeof conditionalClassNames === 'undefined') {
        conditionalClassNames = staticClassName
    }
    else {
        classNames.push(staticClassName)
    }
    for (var className in conditionalClassNames) {
        if (!!conditionalClassNames[className]) {
            classNames.push(className)
        }
    }
    return classNames.join(' ')
}


class CallbackForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            submitted: 0,
            errors: {},
            isValid: true,
            result: {},
            date_begin: "",
            date_end: "",
            data: {},
        };
        this.refs = {};

        if (process.env.NODE_ENV !== "production") {
            //this.apiUrl = "http://localhost/schorsow/dev/landhotel-schorsow.de/kirby/api/";
            this.apiUrl = "http://localhost/ferienhaus.landhotel-schorssow.de/public/php/contact.php";
            this.apiUrl = "https://landhotel-schorssow.de/php/contact.php";
        } else {
            this.apiUrl = "https://landhotel-schorssow.de/php/contact.php";
        }

    }

    static propTypes =  {
        email:      React.PropTypes.bool
        , phone:      React.PropTypes.bool
        , message:      React.PropTypes.bool
    }

    static defaultProps () {
        return {
            email: true
            , phone: true
            , message: true
        };
    }



    componentDidUpdate () {

    }

    isValid = (data) => {
        var fields = ['name', 'phone', 'time'];

        var errorStr = 'Bitte überprüfen Sie die markierten Felder.';

        var errors = {}
        fields.forEach(function(field) {

            //console.log("value - : ",field, data[field]);
            var value = trim(data[field]);
            if (!value) {
                errors[field] = errorStr;
            }

        });

        this.setState({errors: errors});

        var isValid = true;

        for (var error in errors) {
            if (errors[error] === errorStr) {
                isValid = false;
                //break;
            }
        }

        //console.log("error valid " +  isValid);

        this.setState({isValid: isValid});

        return isValid
    }

    getTimeValue (refs) {
        if (refs.timeBeliebig.checked) {
            return "beliebig";
        } else if (refs.timeVormittag.checked) {
            return "Vormittag";
        } else if (refs.timeNachmittag.checked) {
            return "Nachmittag";
        } else if (refs.timeAbend.checked) {
            return "Abend";
        }
        return "";
    }

    getFormData = () => {
        var data = {
            "site": this.props.site,
            "name": this.refs.name.value,
            "phone": this.refs.phone.value,
            "time": this.getTimeValue(this.refs)
        }
        return data;
    }

    componentWillReceiveProps (nextProps) {
        //console.log("data - componentWillReceiveProps: ", nextProps);
        if (nextProps.closed) {
            this.setState ({
                submitted: 0,
                data: {}
            })
        }
    }

    render () {
        if (this.state.submitted === 0) {
            return <div className="form-horizontal">
                <div className={"row"}>
                    <div className={"col-xs-12 col-sm-6"}>
                        {this.renderTextInput('name', 'Name*',"no-bottom")}
                    </div>
                    <div className={"col-xs-12 col-sm-6"}>
                        {this.renderTextInput('phone', 'Telefon*',"no-bottom")}

                    </div>
                    <p className={"duty"}> <small><sup>*</sup>Pflichtfeld</small></p>
                    <div className={"col-xs-12"}>
                        {
                        this.renderRadioInlines('time', 'Wann dürfen wir Sie zurückrufen?', {
                            values: ['Beliebig','Vormittag', 'Nachmittag', 'Abend']
                            , defaultCheckedValue: 'Beliebig'
                        })}
                    </div>
                    <div className={"col-xs-12"}>

                    </div>
                    <div className="col-xs-8">
                    {!this.state.isValid &&
                        <p className="error"><i>Bitte überprüfen Sie Ihre Eingaben.</i></p>
                    }
                    </div>
                    <div className={"col-xs-4"}>
                        <button className="SubmitContactButton ButtonInnerContent" onClick={(e) => this.handleSubmit(e)}>Absenden</button>
                    </div>
                </div>
            </div>
        } else if (this.state.submitted === 2) {
            return <div className="form-horizontal">
                <p>
                    <strong>Ihre Bitte um Rückruf wurde erfolgreich gesendet.</strong><br/>
                    <br/>Danke, wir werden uns schnellstmöglich unter der Nummer {this.state.data.phone} bei Ihnen melden.
                    <br/><br/><i>Ihr Landhotel Schorssow.</i>
                </p>
            </div>
        } else {
            return <div className="form-horizontal">
                <p>Ihre Nachricht wird gesendet...</p>
            </div>
        }
    }

    handleSubmit = (e) => {
        const data = this.getFormData();
        if (this.isValid(data)) {
            this.setState({submitted: 1, data: data});
            this.onValidData(data);
        }
    }

    onValidData (data) {
        //console.log("Callback - onValidData: ", this.props.url, data);
        fetch(this.props.url,{
            headers : {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            method: "POST",
            body:  JSON.stringify(data)
        })
            .then( (response) => {
                return response.json() })
            .then( (json) => {
                //console.log("onValidData - result: " + JSON.stringify(json));
                this.setState({
                    submitted: 2
                });
                this.props.onSend();
            });
    }

    renderTextInput = (id, label, optClass) => {
        return this.renderField(id, label,
            <input type="text" className="form-control" id={id} ref={id} />
        ,optClass)
    }

    renderTextarea = (id, label) => {
        return this.renderField(id, label,
            <textarea className="form-control" id={id} ref={id}/>
        ,"")
    }

    renderCheckbox = (id, headline, label, checked) => {
        //let c = ((checked) ? "checked" : "");
        return <div className={$c('form-group', {'has-error': this.state.errors[id]})} >
            <div className="col-md-3 col-sm-12 col-xs-12">{headline}</div>
            <div className="col-md-9 col-sm-12 col-xs-12">
                <label htmlFor={id} className="control-label-checkbox">
                    <input className="control-checkbox" type="checkbox" name={label} value={label} id={id} ref={id} />
                    {label}
                </label>
            </div>
        </div>

    }

    renderSelect = (id, label, values) => {
        var options = values.map(function(value) {
            return <option value={value}>{value}</option>
        })
        return this.renderField(id, label,
            <select className="form-control" id={id} ref={id}>
                {options}
            </select>
        ,"")
    }

    renderRadioInlines = (id, label, kwargs) => {
        var radios = kwargs.values.map(function(value) {
            var defaultChecked = (value === kwargs.defaultCheckedValue)
            return <label className="radio-inline" key={id + value}>
                <input type="radio" ref={id + value} name={id} value={value} defaultChecked={defaultChecked}/>
                {value}
            </label>
        })
        return this.renderField(id, label, radios, "radio-group")
    }

    renderField = (id, label, field, optClass) => {
        return <div className={$c('form-group ' + optClass, {'has-error': this.state.errors[id]})}>
            <label htmlFor={id} className="col-xs-12 control-label">{label}</label>
            <div className="col-xs-12">
                {field}
            </div>
        </div>
    }


}




export default CallbackForm;



// WEBPACK FOOTER //
// ./src/components/CallbackForm/CallbackForm.js